import * as type from '@app/constants/hotUpdate'

export const sync = () => ({
  type: type.SYNC_HOT_UPDATE,
})
